'use client';

import LinearProgress from '@mui/material/LinearProgress';

import { useRouteLoading } from './store';

const RouteLoadingIndicator = () => {
  const loading = useRouteLoading((state) => state.loading);

  const classes = ['progress', 'async-module-progress'];

  if (!loading) {
    classes.push('disabled');
  }

  return (
    <div className={classes.join(' ')}>
      <LinearProgress />
    </div>
  );
};

export default RouteLoadingIndicator;
